import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { withOktaAuth } from '@okta/okta-react';
import { connect, useDispatch, useSelector, shallowEqual } from 'react-redux';
import BeatLoader from 'react-spinners/BeatLoader';
import { LoadingStyle } from '../../../styles';
import SearchInput from '../../shared/SearchInput';
import React, { useEffect, useMemo, useState } from 'react';
import { Card, Col, Container, Dropdown, Row, Tab, Table, Tabs } from 'react-bootstrap';
import Notifications from 'react-notification-system-redux';
import { ZoomLoggingGrid } from './ZoomLoggingGrid';
import {
    exportZoomCleanLoggingData,
    exportZoomLoggingData,
    fetchZoomCleanLoggingData,
    fetchZoomLoggingData,
} from '../../../actions/admin/zoom-logging.action';
import Button from 'react-bootstrap/Button';
import { ZoomCleanLogGrid } from './ZoomCleanLogGrid';
import moment from 'moment';

const EventType = [{
    id: '', title: 'All',
}, {
    id: 'meeting.created', title: 'Meeting Created',
}, {
    id: 'meeting.updated', title: 'Meeting Updated',
}];

const ZoomLogging = ({ loading, data, cleanLogData, ...props }) => {
    const [searchTerm, setSearchTerm] = useState();
    const [cleanLogSearchTerm, setCleanLogSearchTerm] = useState();
    const [eventType, setEventType] = useState(EventType[0]);
    const [filteredData, setFilteredData] = useState([]);
    const [cleanLogDataFiltered, setCleanLogDataFiltered] = useState([]);
    const [key, setKey] = useState('cleanup');

    const arr = useMemo(() => data, [data]);
    const cleanLog = useMemo(() => cleanLogData, [cleanLogData]);

    const error = useSelector((state) => state.zoomLogging.error, shallowEqual);

    const dispatch = useDispatch();

    // Function to get the current date in PST
    function getPSTDate() {
        return moment().utcOffset(-8 * 60); // PST is UTC-8
    }

    useEffect(() => {
        // Get today's date in PST and format it as YYYY-MM-DD
        const endDate = getPSTDate().format('YYYY-MM-DD');

        // Get the date 2 years ago from today's PST date and format it as YYYY-MM-DD
        const startDate = getPSTDate().subtract(2, 'years').format('YYYY-MM-DD');

        console.log('End Date Clean Up Logs:', endDate);
        console.log('Start Date Clean Up Logs:', startDate);
        //console.log('request data');
        if (props.authState?.isAuthenticated) {
            props.fetchZoomLoggingData({ data: {}, jwt: props.authState.accessToken.accessToken });
            props.fetchZoomCleanLoggingData({
                data: {
                    eventType: 'license.cleanup',
                    startDate: startDate,
                    endDate: endDate
                },
                jwt: props.authState.accessToken.accessToken,
            });
        }
    }, []);

    useEffect(() => {
        setFilteredData(arr);
    }, [arr]);

    useEffect(() => {
        setCleanLogDataFiltered(cleanLog);
    }, [cleanLog]);

    useEffect(() => {
        if (!error) return;
        dispatch(Notifications.error({
            title: 'Unable to save changes', message: error, position: 'tr', autoDismiss: 10,
        }));
    }, [error]);


    const handleSearch = (searchTerm) => {
        setSearchTerm(searchTerm);
        const result = filterData({ searchTerm, data: arr });

        setFilteredData(result);
    };

    const handleSearchEventType = (eventType) => {
        setEventType(eventType);
        const result = filterData({ searchTerm: eventType.id, data: arr });

        setFilteredData(result);
    };

    const handleCleanLogSearch = (searchTerm) => {
        setCleanLogSearchTerm(searchTerm);
        console.log("SET search term: ", searchTerm);
        //console.log("CleanLog data used for filtering: ", cleanLog);
        const result = filterData({ searchTerm, data: cleanLog });
        console.log("SearchFilteredData: ", result);

        setCleanLogDataFiltered(result);
    };

    const filterData = ({ data, searchTerm } = { data: [], searchTerm: '' }) => {
        if (!searchTerm) return data;

        // Filter the data array based on 'eventTimestamp' property includes the search term
        //eventTimestamp needs to be formatted to compare so it is similar to the format shown in UI
        return data.filter((item) =>
            // item.users.toLowerCase().includes(searchTerm.toLowerCase()) ||
            //moment.utc(item.eventTimestamp).local().format('MM/DD/YYYY hh:mm:ss a').toLowerCase().includes(searchTerm.toLowerCase())
            //item.eventTimestamp.toLowerCase().includes(searchTerm.toLowerCase())
            moment.utc(item.eventTimestamp).format('MM/DD/YYYY hh:mm:ss a').toLowerCase().includes(searchTerm.toLowerCase())
        );
    };

    const handlerExportEventLog = () => {
        props.exportZoomLoggingData({
            data: { UserEmail: searchTerm, eventType: eventType.id },
            jwt: props.authState.accessToken.accessToken,
        });
    };
    const handlerExportCleanEventLog = () => {
        //convert date from MM/DD/YYYY to YYYY-MM-DD
        const parts = cleanLogSearchTerm.split('/'); // Split the date string into day, month, and year parts
        const formattedDate = `${parts[2]}-${parts[0].padStart(2, '0')}-${parts[1].padStart(2, '0')}`;
        console.log("Export FormatDate: ", formattedDate);
        props.exportZoomCleanLoggingData({
            // data: { UserEmail: cleanLogSearchTerm },
            data: {
                eventType: 'license.cleanup',
                startDate: formattedDate,
                endDate: formattedDate
            },
            jwt: props.authState.accessToken.accessToken,
        });
    };

    const handlerReload = () => {
        props.fetchZoomLoggingData({
            data: { UserEmail: searchTerm, eventType: eventType.id },
            jwt: props.authState.accessToken.accessToken,
        });
    };

    const handlerCleanUpReload = () => {
        props.fetchZoomCleanLoggingData({
            data: { UserEmail: cleanLogSearchTerm },
            jwt: props.authState.accessToken.accessToken,
        });
    };

    return <Container fluid className="main-panel main-panel-analytics">
        <div className="container">
            <div className="page-inner">
                <Row>
                    <Col>
                        <Card>
                            <Card.Body>
                                <Card.Title>Zoom Log</Card.Title>
                                <Card.Subtitle></Card.Subtitle>
                            </Card.Body>
                            <Card.Body>
                                {loading ? (<BeatLoader css={LoadingStyle} size={12} color={'#1C23BA'} loading={true}
                                    speedMultiplier={0.8} />) : <span />}

                                <Tabs activeKey={key} onSelect={(k) => setKey(k)} className="mb-3">
                                    {/* <Tab eventKey="webhook" title="Webhook">
                                        <Row className="mb-3">
                                            <Col md={4}><SearchInput onSearch={handleSearch} /></Col>
                                            <Col md={4}>
                                                <Row>
                                                    <Col>
                                                        <div className="form-group">
                                                            <Dropdown>
                                                                <Dropdown.Toggle variant="light" id="dropdown-basic">
                                                                    <strong>Event
                                                                        Type:</strong> {eventType?.title || ''}
                                                                </Dropdown.Toggle>

                                                                <Dropdown.Menu>
                                                                    {EventType.map((item) => (
                                                                        <Dropdown.Item key={item.id}
                                                                                       onClick={event => {

                                                                                           handleSearchEventType(item);
                                                                                       }}>{item.title}</Dropdown.Item>
                                                                    ))}
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </div>
                                                    </Col>
                                                    <Col>
                                                        <div className="form-group">
                                                            <Button variant="light" onClick={handlerExportEventLog}><i
                                                                className="fas fa-file-export"
                                                                style={{ color: '#000' }}></i> Export</Button>
                                                        </div>
                                                    </Col>
                                                    <Col>
                                                        <div className="form-group">
                                                            <Button variant="light" onClick={handlerReload}><i
                                                                className="fas fa-sync-alt"
                                                                style={{ color: '#000' }}></i> Refresh</Button>
                                                        </div>
                                                    </Col>
                                                </Row>

                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <ZoomLoggingGrid items={filteredData || []} />

                                            </Col>
                                        </Row>
                                    </Tab> */}
                                    <Tab eventKey="cleanup" title="Clean up">
                                        <Row className="mb-3">
                                            <Col md={4}><SearchInput onSearch={handleCleanLogSearch} /></Col>
                                            <Col md={4}>
                                                <Row>
                                                    <Col>
                                                        <div className="form-group">
                                                            <Button variant="light"
                                                                onClick={handlerExportCleanEventLog}><i
                                                                    className="fas fa-file-export"
                                                                    style={{ color: '#000' }}></i> Export</Button>
                                                        </div>
                                                    </Col>
                                                    <Col>
                                                        <div className="form-group">
                                                            <Button variant="light" onClick={handlerCleanUpReload}><i
                                                                className="fas fa-sync-alt"
                                                                style={{ color: '#000' }}></i> Refresh</Button>
                                                        </div>
                                                    </Col>
                                                </Row>

                                            </Col>
                                        </Row>
                                        <Row><Col>
                                            <ZoomCleanLogGrid items={cleanLogDataFiltered || []} />
                                        </Col></Row>
                                    </Tab>
                                </Tabs>
                            </Card.Body>
                        </Card>

                    </Col>
                </Row>
            </div>
        </div>
    </Container>;
};


const mapStateToProps = (state) => ({
    data: state.zoomLogging.log, loading: state.zoomLogging.loading, cleanLogData: state.zoomLogging.cleanLog,
});


export default compose(withRouter, withOktaAuth, connect(mapStateToProps, {
    fetchZoomLoggingData, exportZoomLoggingData, fetchZoomCleanLoggingData, exportZoomCleanLoggingData,
}))(ZoomLogging);